import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import {
  IconButton,
  makeStyles,
} from "@material-ui/core";
import UserInformation from "./UserInformation";
import { useHistory } from "react-router-dom";
import "./header.scss";
import { Grid } from "@material-ui/core";
import { useTheme } from "../../configurations/themeProvider";
import { DefaultAutocomplete } from "../autocomplete/DefaultAutocomplete";
import { useTranslation } from "react-i18next";
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import stz_logo from "../../images/logo.png";
import stz_logo_dark_mode from "../../images/stz_logo_dark_mode.png";

const useStyles = makeStyles((theme) => ({
  toolbar: {
    minHeight: "90px",
  },
  offset: theme.mixins.toolbar,
  search: {
    marginLeft: "5%",
    width: 300,
  },
  logo: {
    width: 120,
    height: 67,
  }
}));


const Header = () => {
  const { t } = useTranslation();

  const classes = useStyles();
  const history = useHistory();

  const { theme, toggle } = useTheme();

  const userId = sessionStorage.getItem("userId");

  const handleChange = ({ target: { contextKey } }) => {
    if (contextKey !== undefined && contextKey !== null && contextKey !== "") {
      history.push(contextKey);
    }
  };

  return (
    <AppBar className={"header"} elevation={2} position="static">
      <Toolbar className={classes.toolbar}>
        <Grid item xs={10} style={{ display: "flex" }}>
          <Grid item xs={2}>
            <img
              src={theme === 'dark' ? stz_logo_dark_mode : stz_logo}
              className={classes.logo}
              onClick={() => history.replace("/home")}
              alt=''
            />
          </Grid>
          {/* <Grid item xs={3}>
            <DefaultAutocomplete
              name={"menuAutocomplete"}
              onChange={handleChange}
              useApi
              endpoint='GetMenuAutocomplete'
              endPointData={{ userId: userId }}
              placeholder={t("search")}
            />
          </Grid> */}
          {/* <Grid item xs={7} className={"itensGrid"}>
            {/*campo de Atalhos}
            <Grid item>
              <IconButton sx={{ ml: 1 }} onClick={toggle} color={theme === 'dark' ? "inherit" : "default"}>
                {theme === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
              </IconButton>
            </Grid>
          </Grid> */}

        </Grid>
        <Grid item xs={2}>
          <UserInformation />
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
